import { render, staticRenderFns } from "./Studyabroad.vue?vue&type=template&id=6f5f740a&"
import script from "./Studyabroad.vue?vue&type=script&lang=js&"
export * from "./Studyabroad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports